module.exports = __webpack_public_path__ + "assets/img/mask-character.0c521b82.png";